import React, { Component } from "react";
import { Cascader } from "antd";
import { getDictItemList } from "../../service/dict";

import "./index.less";

export default class DictCascader extends Component {

  state = {
    options: [],
  };

  _idMap = {};
  _valueMap = {};

  componentDidMount() {
    this.onLoad().then(options => {
      this.setState({ ...this.state, options, });
    });
  }

  onLoad = () => {
    const { dict: dictCode, } = this.props;
    return getDictItemList({ dictCode, }).then(data => {
      const items = [...data];
      const options = this.getOptions(items);
      return options;
    });
  };

  getOptions = (data) => {
    const options = [];
    data.forEach(item => {
      if (!item.pId) {
        let optionItem = this.toOptionItem(data, item);
        options.push(optionItem);
      }
    });
    return options;
  };

  toOptionItem = (data, item) => {
    this._idMap[item.id] = item;
    this._valueMap[item.value] = item;
    return {
      label: item.label,
      value: this.parse(item.value),
      children: this.getChildren(data, item),
    };
  };

  getChildren = (data, pItem) => {
    const children = [];
    data.forEach(item => {
      if (pItem.id === item.pId) {
        let optionItem = this.toOptionItem(data, item);
        children.push(optionItem);
      }
    });
    return children;
  };

  parse = (value) => {
    const { parse } = this.props;
    if (typeof parse === "string") {
      return {
        "number": Number,
        "string": String,
      }[parse](value);
    }
    return parse(value);
  };

  getValue = () => {
    if(this.props.multiple) return // 多选时不做处理

    const values = [];
    if (this.props.value) {
      let item = this._valueMap[this.props.value];
      if (item) {
        values.push(item.value);
        while (item.pId in this._idMap) {
          item = this._idMap[item.pId];
          values.splice(0, 0, item.value);
        }
      }
    }
    return values;
  };

  onChange = (values, selectedOptions) => {
    let value = null
    if (this.props.multiple) { // 多选
      value = values
    } else {
      // 单选
      value = values ? values[values.length - 1] : values;
    }
    this.props.onChange && this.props.onChange(value, selectedOptions);
  };

  render() {
    const { options } = this.state;
    return (
      <Cascader
        {...this.props}
        options={options}
        value={this.getValue()}
        onChange={this.onChange}
      />
    );
  };
};
